import React, { useEffect, useState } from "react";
import { Alert, Box, CircularProgress, Paper, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { GetCurrentCompetitionSurvey } from "../api/CompetitionSurveyApi";

const CompetitionSurvey = () => {
  const { token, lang } = useSelector((state) => state.user);

  const [survey, setSurvey] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    console.log("CompetitionSurvey mounted");
    console.log("token:", token);
    console.log("lang:", lang);

    const loadSurvey = async () => {
      try {
        console.log("Calling GetCurrentCompetitionSurvey...");

        setLoading(true);
        setError("");

        const result = await GetCurrentCompetitionSurvey(token);

        console.log("Survey result:", result);

        setSurvey(result);
      } catch (err) {
        console.error("Competition Survey error:", err);

        setError(
          lang === "FR"
            ? "Une erreur est survenue lors du chargement de l'enquête."
            : "An error occurred while loading the survey.",
        );
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      loadSurvey();
    } else {
      console.log("NO TOKEN - API call skipped");
      setLoading(false);
    }
  }, [token, lang]);

  // Loading
  if (loading) {
    return (
      <Box
        sx={{
          minHeight: "70vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // API error
  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  // Multiple active surveys
  if (survey?.status === "MultipleActive") {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">
          {lang === "FR"
            ? "Erreur - plus d’une enquête active. Veuillez contacter le service TI."
            : "Error - more than one active survey. Please contact IT"}
        </Alert>
      </Box>
    );
  }

  // No active survey
  if (survey?.status === "Closed") {
    return (
      <Box
        sx={{
          minHeight: "70vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          p: 3,
        }}
      >
        <Paper
          elevation={3}
          sx={{
            maxWidth: 600,
            width: "100%",
            textAlign: "center",
            p: 6,
            borderRadius: 3,
          }}
        >
          <Typography variant="h4" fontWeight={600} gutterBottom>
            {lang === "FR"
              ? "Temporairement indisponible"
              : "Temporarily Closed"}
          </Typography>

          <Typography variant="body1" color="text.secondary">
            {lang === "FR"
              ? "Veuillez réessayer plus tard."
              : "Please check back later."}
          </Typography>
        </Paper>
      </Box>
    );
  }

  // Active survey
  if (survey?.status === "Available" && survey?.surveyLink) {
    return (
      <Box
        sx={{
          width: "100%",
          height: "calc(100vh - 120px)",
          overflow: "hidden",
        }}
      >
        <iframe
          src={survey.surveyLink}
          title={
            lang === "FR" ? "Enquête de compétition" : "Competition Survey"
          }
          style={{
            width: "100%",
            height: "100%",
            border: "none",
          }}
        />
      </Box>
    );
  }

  // Unexpected response
  return (
    <Box sx={{ p: 3 }}>
      <Alert severity="warning">
        {lang === "FR"
          ? "L'enquête de compétition n'est pas disponible."
          : "The competition survey is not available."}
      </Alert>
    </Box>
  );
};

export default CompetitionSurvey;
